// extracted by mini-css-extract-plugin
module.exports = {"error":"Error_error__NuFxq","title":"Error_title__14kAf","links":"Error_links__XXqOo","link":"Error_link__3bC2k"};